/**
 * 2007-2017 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2017 PrestaShop SA
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import 'bootstrap/js/src/util';
import 'bootstrap/js/src/alert';
import 'bootstrap/js/src/button';
import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/dropdown';
import 'bootstrap/js/src/modal';
import 'bootstrap/js/src/popover';
import 'bootstrap/js/src/tab';
import 'bootstrap/js/src/toast';
import 'bootstrap/js/src/tooltip';
import 'bootstrap-touchspin';
import './lib/jquery.hoverIntent.min';

import 'slick-carousel/slick/slick.min';
import 'leaflet/dist/leaflet';
import 'leaflet.markercluster/dist/leaflet.markercluster';

import './responsive';
import './checkout';
import './customer';
import './listing';
import './product';
import './cart';
import './fixed-header';

import Form from './components/form';
import TopMenu from './components/top-menu';

import prestashop from 'prestashop';
import EventEmitter from 'events';
import lazysizes from 'lazysizes'


import './components/block-cart';

// "inherit" EventEmitter
for (var i in EventEmitter.prototype) {
    prestashop[i] = EventEmitter.prototype[i];
}

$(document).ready(() => {
    const form = new Form();
    let topMenuEl = $('#_desktop_top_menu #top-menu');
    let topMenu = new TopMenu(topMenuEl);

    form.init();
    topMenu.init();

    //display input file content in custom file input BS
    $('.custom-file-input').on('change', function() {
        let fileName = $(this).val().split('\\').pop();
        $(this).next('.custom-file-label').addClass("selected").html(fileName);
    });

    $('#menu-icon').on('click', function() {
        if (!$("body").hasClass("modal-open")) {
            $(this).children("i").text("close");
        } else {
            $(this).children("i").text("menu");
        }
    });

    $('#mobile_top_menu_wrapper').on('click', function() {
        $('#menu-icon').trigger('click');
    });

    $('#mobile_top_menu_wrapper .modal-dialog').on('click', function(e) {
        e.stopPropagation();
    });
});
document.addEventListener('lazyloaded', function(e) {
    $(e.target).parent().addClass('rc--lazyload');
});

$('.product-selection-gps__list_large').slick({
    dots: false,
    speed: 500,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: false,
    prevArrow: '<span class="previous"><i class="icon-left-chevron"></i></span>',
    nextArrow: '<span class="next"><i class="icon-right-chevron"></i></span>',
    responsive: [
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 2,
            },
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
            },
        },
    ],
});

$('.product-selection-gps__list_medium').slick({
    dots: false,
    speed: 500,
    infinite: true,
    slidesToScroll: 1,
    slidesToShow: 2,
    centerMode: false,
    prevArrow: '<span class="previous"><i class="icon-left-chevron"></i></span>',
    nextArrow: '<span class="next"><i class="icon-right-chevron"></i></span>',
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
            },
        },
    ],
});

$('.product-selection-gps__list_small').slick({
    dots: false,
    speed: 500,
    infinite: true,
    slidesToScroll: 1,
    centerMode: false,
    prevArrow: '<span class="previous"><i class="icon-left-chevron"></i></span>',
    nextArrow: '<span class="next"><i class="icon-right-chevron"></i></span>',
});

/* --- Slick --- */
$('.product-images-container').slick({
    prevArrow: '<span class="previous"><i class="icon-left-chevron"></i></span>',
    nextArrow: '<span class="next"><i class="icon-right-chevron"></i></span>',
    lazyLoad: 'progressive',
});

$('.shop-slider').slick({
    prevArrow: '<span class="previous"><i class="icon-left-chevron"></i></span>',
    nextArrow: '<span class="next"><i class="icon-right-chevron"></i></span>',
    lazyLoad: 'progressive',
    asNavFor: '.shop-slider-nav',
    adaptiveHeight: true,
});

$('.shop-slider-nav').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    lazyLoad: 'progressive',
    asNavFor: '.shop-slider',
    arrows: false,
    focusOnSelect: true,
    variableWidth: true,
});

/* --- Icon Fav --- */
$(document).on('click', '.icon-fav', function() {
    $(this).toggleClass('active');
});

/* --- AOS --- */
import AOS from 'aos';

AOS.init({
    startEvent: 'load',
    disable: 'phone',
    once: true,
    duration: 500,
    delay: 200,
    offset: 0,
});

/* --- Switch view product --- */
$(document).on('click', '.view-modes > li', function() {
    $(this).siblings().removeClass('current');
    $(this).addClass('current');

    var listView = $('#products').find('[data-view="list"]');
    var mapView = $('#products').find('[data-view="map"]');

    var currentElement = $(this).attr('id').split('-');
    currentElement = currentElement[1];

    if (currentElement == 'list') {
        $(listView).show();
        $(mapView).hide();
        $('.sort-by-row').show();
    } else if (currentElement == 'map') {
        $(listView).hide();
        $('.sort-by-row').hide();

        var mapLeafletContainer = document.getElementById('map-leaflet');
        if (typeof (mapLeafletContainer) != 'undefined' && mapLeafletContainer != null) {
            $(mapView).show();
        } else {
            $(mapView).append('<div id="map-leaflet"></div>');
            initializeLeaflet('map-leaflet', 'GetGeoJson', null, false);
        }
    }
});

$('.more-filter').click(function() {
    var scrollDown = $(".search-container").offset().top - 220;
    $('html,body').animate({scrollTop: scrollDown}, 'slow');
});

$(window ).load(function() {
    $('#homevideoblock').html('<video autoplay muted loop>\n' +
        '    <source src="/themes/classic-rocket/assets/video/video-cc-V4.webm" type="video/webm">\n' +
        '  </video>');
    $('#homevideoblock video').css('display', 'inherit');
});



// WEBPACK FOOTER //
// ./js/theme.js